<template>
  <el-card class="my-box-card">
    <el-form :model="user" ref="userForm" label-width="120px" label-position="right" :rules="rules">
      <el-divider>修改密码</el-divider>
      <el-form-item label="旧密码" prop="oldPwd">
        <el-input v-model="user.oldPwd" type="password" auto-complete="off" placeholder="请输入旧密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd">
        <el-input type="password" v-model="user.newPwd" auto-complete="off" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="再次输入新密码" prop="confirmPwd">
        <el-input type="password" v-model="user.confirmPwd" auto-complete="off" placeholder="请再次输入新密码">
        </el-input>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <div  class="clearfix" style="text-align: center">
      <el-button :loading="loading" size="medium" type="warning" @click="handleReset">确认</el-button>
      <!--<el-button size="medium" type="primary" @click="handleSave">保存</el-button>-->
    </div>
  </el-card>
</template>

<script>
import { changePwd } from '@/api/user/user'
import { mapActions } from 'vuex'

export default {
  name: 'userInfo',
  data () {
    // 重复密码验证
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.user.confirmPwd !== '') {
          this.$refs.userForm.validateField('confirmPwd')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.user.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      user: {},
      loading: false,
      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请输入确认新密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur', required: true }
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['handleLogOut']),
    handleReset () {
      this.$refs['userForm'].validate(valid => {
        if (valid) {
          this.loading = true
          changePwd(this.user).then(res => {
            this.loading = false
            var result = res.data
            if (result.rtnCode !== '0') {
              this.$message({
                type: 'info',
                message: result.msg
              })
            } else {
              // 重新登录
              this.$message.success('修改密码成功！')
              this.handleLogOut()
              this.$router.push({
                name: this.$config.loginName
              })
            }
          }).catch(ex => {
            this.loading = false
            this.$message.error('修改密码失败，请稍后再试！')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
